import { render } from "./RiskForm.vue?vue&type=template&id=479ea8ca"
import script from "./RiskForm.vue?vue&type=script&lang=js"
export * from "./RiskForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__